import {
	CognitoErrorCode,
	hasCognitoErrorCode,
	MaybeCognitoError,
} from '@move-frontend/auth';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

export function useResetPasswordErrorMessage(error: MaybeCognitoError) {
	const { t } = useTranslation();

	if (hasCognitoErrorCode(error, CognitoErrorCode.ExpiredCodeException)) {
		return t('user_reset_password_expired_code_error');
	}

	if (hasCognitoErrorCode(error, CognitoErrorCode.LimitExceededException)) {
		return t('user_reset_password_limit_exceeded_error');
	}

	return t('user_reset_password_generic_error');
}
